var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAdvanced(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1617006067630,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1903,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 128a384 384 0 1 0 384 384A384 384 0 0 0 512 128z m0 563.2a179.2 179.2 0 1 1 179.2-179.2 179.2 179.2 0 0 1-179.2 179.2z",
    "p-id": 1904
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M614.4 168.448L588.8 0h-153.6L409.6 168.448a358.4 358.4 0 0 1 204.8 0zM409.6 855.552L435.2 1024h153.6l25.6-168.448a358.4 358.4 0 0 1-204.8 0z m417.792-514.048l102.4-137.216L819.2 95.744l-137.216 102.4a358.4 358.4 0 0 1 144.896 144.896zM196.608 682.496L95.744 819.2 204.8 928.256l137.216-102.4a358.4 358.4 0 0 1-144.896-144.896zM855.552 614.4l168.448-25.6v-153.6L855.552 409.6a358.4 358.4 0 0 1 0 204.8zM168.448 409.6L0 435.2v153.6l168.448 25.6a358.4 358.4 0 0 1 0-204.8z m514.048 417.792l137.216 102.4L928.256 819.2l-102.4-137.216a358.4 358.4 0 0 1-144.896 144.896zM341.504 196.608L204.8 95.744 95.744 204.8l102.4 137.216a358.4 358.4 0 0 1 143.36-145.408z",
    "p-id": 1905
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdvanced);
export default __webpack_public_path__ + "static/media/icon-advanced.111cdd2d0b61ebbc8eaab92369a7bf83.svg";
export { ForwardRef as ReactComponent };